import { Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import React, { useEffect, useState } from "react";
import { months } from "../../utilities/const/const";
import { getClass } from "../../utilities/const/functions";
import ClassAttendanceTable from "./ClassAttendanceTable";
import { textEllipses } from "../../utilities/commonStyles/commonStyles";

export default function ClassDiv({
  data,
  getTeacherName,
  getLevelName,
  studentInfo,
  getDivisionImage,
}) {
  const [classData, setClassData] = useState({});
  // console.log({ studentInfo });
  const fetchClassInfo = async () => {
    try {
      const res = await getClass(data);
      if (!res.error) {
        setClassData(res.data);
      } else {
        window.alert(res.message);
      }
    } catch (e) {
      console.log(e);
    }
  };

  // useEffect(() => {
  //   fetchClassInfo();
  // }, [data]);

  return (
    <Box
      sx={{
        display: "flex",
        mt: "20px",
        height: "200px",
      }}
    >
      <Box
        sx={{
          minWidth: "250px",
        }}
      >
        <Typography
          sx={{ fontSize: "14px", fontWeight: 500, color: "#8CBE21" }}
        >
          {data.classCode}
        </Typography>
        <Box sx={{ display: "flex", gap: "20px", mt: "20px" }}>
          <Box sx={{ width: "100px" }}>
            <img
              style={{ width: "100px" }}
              src={getDivisionImage(data?.division)}
              alt=""
            />
          </Box>
          <Stack spacing={1}>
            {/* <Typography
              sx={{ fontSize: "14px", fontWeight: 500, color: "#5C5C5C" }}
            >
              Sunday
            </Typography> */}
            <Typography
              sx={{
                width: "90px",
                fontSize: "14px",
                fontWeight: 500,
                color: "#5C5C5C",
                ...textEllipses,
              }}
            >
              {data?.classTimeFrom}
            </Typography>
            <Typography
              sx={{
                width: "90px",
                fontSize: "14px",
                fontWeight: 500,
                color: "#5C5C5C",
                ...textEllipses,
              }}
            >
              {/* {console.log({ data })} */}
              {getTeacherName(data?.teacher)}
            </Typography>
            <Typography
              sx={{
                width: "90px",
                fontSize: "14px",
                fontWeight: 500,
                color: "#5C5C5C",
                ...textEllipses,
              }}
            >
              {getLevelName(data?.level)}
            </Typography>
            <Typography
              sx={{
                width: "90px",
                fontSize: "14px",
                fontWeight: 500,
                color: "#5C5C5C",
                ...textEllipses,
              }}
            >
              {months[data.intakeMonth]}
            </Typography>
          </Stack>
        </Box>
      </Box>

      <Box
        sx={{
          //   minWidth: "100%",
          overflow: "auto",
        }}
      >
        <ClassAttendanceTable studentInfo={studentInfo} classData={data} />
      </Box>
    </Box>
  );
}
